<h1 mat-dialog-title>
	Szczegóły połączenia: {{ data.stopFrom.location.name }} <i class="fas fa-arrow-right"></i>
	{{ data.stopTo.location.name }}
</h1>
<mat-dialog-content>
	@if (stopConnectionForm) {
		<div class="d-flex w-100 justify-content-between">
			<ng-container
				*ngTemplateOutlet="
					stopConnectionInputTemp;
					context: { controlName: 'minutes', label: 'Czas przejazdu:', unit: 'min' }
				"
			></ng-container>

			<ng-container
				*ngTemplateOutlet="
					stopConnectionInputTemp;
					context: { controlName: 'kilometers', label: 'Ilość kilometrów:', unit: 'km' }
				"
			></ng-container>
		</div>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-raised-button color="warn" mat-dialog-close>Anuluj</button>
	<button
		mat-raised-button
		color="primary"
		[disabled]="stopConnectionForm.invalid"
		(click)="emitSaveStopConnection()"
	>
		Zapisz
	</button>
</mat-dialog-actions>

<ng-template #stopConnectionInputTemp let-controlName="controlName" let-label="label" let-unit="unit">
	<ng-container [formGroup]="stopConnectionForm">
		<mat-form-field class="field-with-padding" style="width: 49%">
			<mat-label>{{ label }}</mat-label>
			<input matInput class="stop-connection-input" type="number" [formControlName]="controlName" />
			<span matSuffix>{{ unit }}</span>
			@if (
				stopConnectionForm.get(controlName).invalid &&
				(stopConnectionForm.get(controlName).dirty || stopConnectionForm.get(controlName).touched)
			) {
				<mat-error>
					@if (stopConnectionForm.get(controlName).hasError('required')) {
						To pole jest wymagane
					} @else if (stopConnectionForm.get(controlName).hasError('min')) {
						Wartość nie może być mniejsza od 0
					} @else if (stopConnectionForm.get(controlName).hasError('pattern')) {
						Wartość musi być liczbą całkowitą
					}
				</mat-error>
			}
		</mat-form-field>
	</ng-container>
</ng-template>
